angular.module('videoQuickView',['App.video.service','jv.Common.Directives.fallbackImage'])
    .controller('QuickViewVideoController',['$rootScope', '$scope', 'videoService', function($rootScope, $scope, videoService){
        $rootScope.listResult = null;
        $rootScope.videoQuickViewCount = null;
        // for showing different links on the quick view on the candidate list page.
        
        if(angular.isDefined($rootScope.quickViewVideoListListener) || angular.isDefined($rootScope.quickViewVideoCountListener)){
            $rootScope.quickViewVideoListListener();
            $rootScope.quickViewVideoCountListener();
        }

        $rootScope.quickViewVideoCountListener = JV.AngularUtils.scope().$on('GET_QUICKVIEW_VIDEO_COUNT',function(event, applicationEId){
            videoService.getCompleteVideoInterviewCount(applicationEId, function(results){
                $rootScope.videoQuickViewCount = results.completedVideoCount;
            });
        });

        $rootScope.quickViewVideoListListener = JV.AngularUtils.scope().$on('GET_QUICKVIEW_VIDEO_LIST', function(event, applicationEId){
            $rootScope.$broadcast('SHOW_QUICK_VIEW_LOADING');
            videoService.getCandidatesApplicationList({eID:applicationEId}, function(result){
                $rootScope.videoQuickView = true;
                $rootScope.appId = applicationEId;
                $rootScope.listResult = result.resultList;
                $rootScope.$broadcast('HIDE_QUICK_VIEW_LOADING');
            });
        })
        
    }])